/**
 * @generated SignedSource<<1b756b09ea76044903354c2d6140d370>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "UserTokenNodeConnection",
    "kind": "LinkedField",
    "name": "allUsertokens",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserTokenNodeEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserTokenNode",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "token",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "authApiService_allUserTokenQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "authApiService_allUserTokenQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "c2267672b83df5bb2d6e6f5f5e2eca0c",
    "id": null,
    "metadata": {},
    "name": "authApiService_allUserTokenQuery",
    "operationKind": "query",
    "text": "query authApiService_allUserTokenQuery {\n  allUsertokens {\n    edges {\n      node {\n        id\n        token\n        description\n      }\n    }\n  }\n}\n"
  }
};
})();

node.hash = "17e284d099713d6dbaf2eb8ef83bb21c";

module.exports = node;
